module.exports = __webpack_public_path__ + "img/Monte_Kope_66.dfc25593.jpg";